import React, { useState, useEffect } from 'react';
import BackButton from '../components/BackButton';

const TestTerritoires = () => {
  const [result, setResult] = useState('Testing...');
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const test = async () => {
      try {
        
        if (!BACKEND_URL) {
          setResult('ERROR: BACKEND_URL is undefined!');
          return;
        }

        const response = await fetch(`${BACKEND_URL}/api/territoires`);

        if (response.ok) {
          const data = await response.json();
          setResult(`SUCCESS! Got ${data.length} territoires`);
        } else {
          setResult(`HTTP Error ${response.status}`);
        }
      } catch (error) {
        setResult(`CATCH: ${error.name} - ${error.message}`);
      }
    };

    test();
  }, [BACKEND_URL]);

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      
      {/* Bouton Retour */}
      <BackButton label="Retour" />

<h1>Test API Territoires</h1>
      <div style={{ background: '#f0f0f0', padding: '10px', marginTop: '10px' }}>
        <strong>BACKEND_URL:</strong> {BACKEND_URL || 'UNDEFINED'}
      </div>
      <div style={{ background: result.includes('SUCCESS') ? '#d4edda' : '#f8d7da', padding: '10px', marginTop: '10px' }}>
        <strong>Result:</strong> {result}
      </div>
      <div style={{ marginTop: '20px', fontSize: '12px' }}>
        Ouvrez la console (F12) pour voir les logs détaillés
      </div>
    </div>
  );
};

export default TestTerritoires;
